(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pc-cookies"] && !Shopify.designMode) return;
  try {
    
/* Bannière cookies Mallow (sections/pc-cookies.liquid) */
(function () {
  'use strict';
  if (window.__pcCookies) return;
  window.__pcCookies = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = null;
  var timers = [];
  var waiters = [];
  var loading = false;

  function editing() { return !!(window.Shopify && window.Shopify.designMode); }
  function api() { return window.Shopify && window.Shopify.customerPrivacy; }
  function later(fn, ms) { timers.push(setTimeout(fn, ms)); }
  function clearTimers() { timers.forEach(clearTimeout); timers = []; }
  function outMs() {
    var v = parseFloat(getComputedStyle(root).getPropertyValue('--ck-out'));
    return reduce ? 60 : (isNaN(v) ? 800 : v);
  }
  function cats() { return Array.prototype.slice.call(root.querySelectorAll('[data-ck-cat]')); }

  /* L'API se charge à la demande ; les appels en attente passent dès qu'elle est prête. */
  function withApi(fn) {
    var cp = api();
    if (cp && cp.setTrackingConsent) { fn(cp); return; }
    var S = window.Shopify;
    if (!S || typeof S.loadFeatures !== 'function') return;
    waiters.push(fn);
    if (loading) return;
    loading = true;
    S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      loading = false;
      var list = waiters;
      waiters = [];
      if (err || !api()) return;
      list.forEach(function (f) { f(api()); });
    });
  }

  function bind() {
    var el = document.querySelector('[data-ck]');
    root = el;
    if (!el) return false;
    if (!el.__ck) {
      el.__ck = true;
      el.addEventListener('click', onClick);
    }
    return true;
  }

  function show(opts) {
    if (!bind()) return;
    clearTimers();
    var cur = opts && opts.current;
    cats().forEach(function (c) { c.checked = !!(cur && cur[c.getAttribute('data-ck-cat')] === 'yes'); });
    var open = !!(opts && opts.custom);
    root.classList.remove('is-in', 'is-out');
    root.classList.toggle('is-custom', open);
    root.removeAttribute('data-choice');
    var t = root.querySelector('[data-ck-custom]');
    if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
    root.hidden = false;
    void root.offsetWidth;            /* repart de l'état initial avant d'animer */
    root.classList.add('is-in');
  }

  function hide() {
    if (!root) return;
    clearTimers();
    root.hidden = true;
    root.classList.remove('is-in', 'is-out', 'is-custom');
  }

  function choose(kind) {
    if (root.hidden || root.classList.contains('is-out')) return;
    var v = {};
    cats().forEach(function (c) {
      if (kind === 'accept') c.checked = true;
      if (kind === 'refuse') c.checked = false;
      v[c.getAttribute('data-ck-cat')] = c.checked;
    });
    if (!editing()) {
      withApi(function (cp) {
        cp.setTrackingConsent({
          preferences: !!v.preferences,
          analytics: !!v.analytics,
          marketing: !!v.marketing,
          sale_of_data: !!v.marketing
        }, function () {});
      });
    }
    root.setAttribute('data-choice', kind);
    root.classList.add('is-out');
    later(hide, outMs());
  }

  function onClick(e) {
    var t = e.target.closest('[data-ck-accept],[data-ck-refuse],[data-ck-save],[data-ck-custom]');
    if (!t) return;
    if (t.hasAttribute('data-ck-custom')) {
      var open = !root.classList.contains('is-custom');
      root.classList.toggle('is-custom', open);
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    choose(t.hasAttribute('data-ck-accept') ? 'accept' : t.hasAttribute('data-ck-refuse') ? 'refuse' : 'save');
  }

  /* « Gérer mes cookies » : posé dans le pied de page, juste après le lien Confidentialité. */
  function footerLink() {
    if (!bind()) return;
    var label = root.getAttribute('data-ck-footer');
    if (!label || document.querySelector('[data-ck-open]')) return;
    var ref = document.querySelector('.slfd-legal a[href*="confidentialite"], footer a[href*="/pages/confidentialite"], footer a[href*="/policies/privacy-policy"]');
    if (!ref) return;
    var a = document.createElement('a');
    a.href = '#cookies';
    a.setAttribute('data-ck-open', '');
    a.textContent = label;
    ref.parentNode.insertBefore(a, ref.nextSibling);
  }

  /* Bannière vue : on ne la repropose pas à la page suivante. Cookie
     strictement nécessaire (il ne sert qu'à ça). « visite » : jusqu'à la
     fermeture du navigateur ; « six_mois » : durée conseillée par la CNIL. */
  function vue(rappel) {
    if (rappel === 'page') return;
    document.cookie = 'mallow_ck_vu=1; path=/; SameSite=Lax'
      + (rappel === 'six_mois' ? '; max-age=' + 182 * 86400 : '')
      + (location.protocol === 'https:' ? '; Secure' : '');
  }

  /* Changer d'avis : volet ouvert, interrupteurs sur le choix en cours. */
  function reopen() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function' || editing()) {
      show({ custom: true });
      return;
    }
    withApi(function (cp) {
      show({ custom: true, current: cp.currentVisitorConsent ? cp.currentVisitorConsent() : null });
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-ck-open], a[href="#cookies"]');
    if (!t || !document.querySelector('[data-ck]')) return;
    e.preventDefault();
    reopen();
  });

  /* Éditeur de thème : la bannière s'affiche quand sa section est sélectionnée. */
  function ours(e) { return e.target && e.target.querySelector && e.target.querySelector('[data-ck]'); }
  document.addEventListener('shopify:section:select', function (e) { if (ours(e)) show(); });
  document.addEventListener('shopify:section:deselect', function (e) { if (ours(e)) hide(); });
  document.addEventListener('shopify:section:unload', function (e) { if (ours(e)) root = null; });
  document.addEventListener('shopify:section:load', function (e) {
    if (ours(e)) show();
    footerLink();
  });

  function start() {
    if (!bind()) return;
    footerLink();
    if (editing()) return;
    /* On attend que le rideau de page se soit levé (1,25 s en CSS). */
    var delay = document.querySelector('.pt') ? 1350 : 400;
    var tous = root.getAttribute('data-ck-audience') !== 'regions';
    var rappel = root.getAttribute('data-ck-rappel') || 'visite';
    var dejaVue = rappel !== 'page' && /(?:^|;\s*)mallow_ck_vu=1/.test(document.cookie);
    if (dejaVue) return;
    withApi(function (cp) {
      var c = (cp.currentVisitorConsent && cp.currentVisitorConsent()) || {};
      var pasChoisi = !c.marketing && !c.analytics && !c.preferences;
      var exige = cp.shouldShowBanner && cp.shouldShowBanner();
      if (exige || (tous && pasChoisi)) setTimeout(function () { show(); vue(rappel); }, delay);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-features"] && !Shopify.designMode) return;
  try {
    
/* Tube gradué de pc-features.
   - tube simple : niveau et graduations calés sur chaque ligne, texte en accordéon ;
   - flacon (.pc-tube--vial) : fenêtre de 3 actifs qui défile, le haut flouté,
     le sérum suit le défilement en continu. */
if (!customElements.get('pc-tube')) {
  customElements.define('pc-tube', class extends HTMLElement {
    connectedCallback() {
      this.tube = this.querySelector('.pc-tube__tube');
      this.liq = this.querySelector('.pc-tube__liq');
      this.view = this.querySelector('.pc-tube__view');
      this.items = [...this.querySelectorAll('.pc-tube__it')];
      if (!this.items.length || !this.tube) return;
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(ev => this.addEventListener(ev, () => this.stop(), { passive: true }));
      this.addEventListener('click', e => {
        const li = e.target.closest('.pc-tube__it');
        if (li) { this.stop(); this.go(this.items.indexOf(li)); }
      });
      this.fitTitles();
      if (this.view) this.initVial(); else this.initTube();
      if (this.dataset.frames) this.initSeq();
      addEventListener('resize', this.onResize);
      if (document.fonts) document.fonts.ready.then(this.onResize);
      const ms = +this.dataset.autoplay;
      if (ms && !matchMedia('(prefers-reduced-motion: reduce)').matches && !window.Shopify?.designMode) {
        // ne démarre qu'une fois la section à l'écran
        this.io = new IntersectionObserver(([e]) => {
          if (e.isIntersecting && !this.timer && !this.stopped) {
            this.timer = setInterval(() => this.go((this.cur + 1) % this.items.length), ms);
          } else if (!e.isIntersecting && this.timer) { clearInterval(this.timer); this.timer = null; }
        }, { threshold: .4 });
        this.io.observe(this);
      }
    }
    disconnectedCallback() {
      removeEventListener('resize', this.onResize);
      this.ro?.disconnect(); this.io?.disconnect(); this.seqIO?.disconnect(); clearInterval(this.timer); clearTimeout(this.settle);
    }
    // même taille pour tous les titres, la plus grande qui laisse le plus long sur une ligne
    fitTitles() {
      const hs = this.items.map(li => li.querySelector('h3')).filter(Boolean);
      if (!hs.length) return;
      hs.forEach(h => h.style.fontSize = '');
      let fs = parseFloat(getComputedStyle(hs[0]).fontSize);
      const over = () => hs.some(h => h.scrollWidth > h.clientWidth + .5);
      while (over() && fs > 11) { fs -= .5; hs.forEach(h => h.style.fontSize = fs + 'px'); }
    }
    stop() { this.stopped = true; this.classList.add('is-touched'); clearInterval(this.timer); this.timer = null; }
    go(i) { this.view ? this.scrollToItem(i) : this.show(i); }

    /* ---------- tube simple ---------- */
    initTube() {
      this.cur = Math.max(0, this.items.findIndex(li => li.classList.contains('is-on')));
      this.onResize = () => { this.fitTitles(); this.place(); };
      if (window.ResizeObserver) { this.ro = new ResizeObserver(this.onResize); this.ro.observe(this); }
      this.place();
    }
    show(i) {
      this.cur = i;
      this.items.forEach((li, k) => {
        li.classList.toggle('is-on', k === i);
        li.querySelector('button')?.setAttribute('aria-expanded', k === i);
      });
      this.place(); setTimeout(() => this.place(), 480);
    }
    place() {
      this.tube.querySelectorAll('.pc-tube__tick').forEach(t => t.remove());
      const tb = this.tube.getBoundingClientRect();
      this.items.forEach(li => {
        const b = li.querySelector('button').getBoundingClientRect(), mid = b.top + b.height / 2 - tb.top;
        const t = document.createElement('i'); t.className = 'pc-tube__tick'; t.style.top = mid + 'px'; this.tube.appendChild(t);
        const s = document.createElement('i'); s.className = 'pc-tube__tick is-s'; s.style.top = (mid + b.height / 2 + 2) + 'px'; this.tube.appendChild(s);
      });
      const on = this.items[this.cur]?.querySelector('button').getBoundingClientRect();
      if (on) this.liq.style.height = Math.max(0, tb.bottom - (on.top + on.height / 2)) + 'px';
    }

    /* ---------- flacon ---------- */
    initVial() {
      const n = this.items.length;
      this.cur = -1; this.pos = 0;
      this.items.forEach(li => li.querySelector('button')?.removeAttribute('aria-expanded'));
      // position dans la liste (0 = premier actif, en bas) déduite du défilement
      this.onScroll = () => {
        const m = this.maxScroll();
        this.pos = m > 0 ? (1 - this.view.scrollTop / m) * (n - 1) : 0;
        const act = Math.max(0, Math.min(n - 1, Math.round(this.pos)));
        if (act !== this.cur) {
          this.cur = act;
          this.items.forEach((li, k) => li.classList.toggle('is-on', k === act));
          this.ticks();
        }
        this.level(); this.blur();
        clearTimeout(this.settle);
        this.settle = setTimeout(() => { if (Math.abs(this.pos - this.cur) > .03) this.scrollToItem(this.cur); }, 160);
      };
      this.view.addEventListener('scroll', this.onScroll, { passive: true });
      this.onResize = () => {
        this.fitTitles();
        this.fit();
        this.view.scrollTop = this.maxScroll() * (1 - Math.max(0, this.cur) / Math.max(1, n - 1));
        this.cur = -1; this.onScroll();
      };
      this.fit();
      this.view.scrollTop = this.maxScroll();
      this.onScroll();
    }
    // fenêtre = les 3 actifs consécutifs les plus hauts + la bande floutée
    fit() {
      // mesuré bord à bord (écarts entre cartes compris) ; 01 est en bas
      const zone = this.zone(), r = this.items.map(li => li.getBoundingClientRect());
      let best = 0;
      for (let k = 0; k + 3 <= r.length; k++) best = Math.max(best, r[k].bottom - r[k + 2].top);
      if (!best) best = r[0].bottom - r[r.length - 1].top;
      this.view.style.height = Math.round(best + zone * .8) + 'px';
    }
    zone() { return parseFloat(getComputedStyle(this).getPropertyValue('--zone')) || 58; }
    maxScroll() { return this.view.scrollHeight - this.view.clientHeight; }
    scrollToItem(k) {
      this.view.scrollTo({ top: this.maxScroll() * (1 - k / Math.max(1, this.items.length - 1)), behavior: 'smooth' });
    }
    // flacon : niveaux entre le bas (80 %) et les épaules (13 %) ; les autres contenants règlent leurs bornes en CSS
    // bornes du niveau propres à chaque contenant (--lvl-lo, --lvl-hi, --lvl-base)
    lvl() {
      if (!this._lvl) {
        const cs = getComputedStyle(this), v = (k, d) => parseFloat(cs.getPropertyValue(k)) || d;
        this._lvl = { lo: v('--lvl-lo', .8), hi: v('--lvl-hi', .13), base: cs.getPropertyValue('--lvl-base').trim() ? parseFloat(cs.getPropertyValue('--lvl-base')) : 8 };
      }
      return this._lvl;
    }
    y(p) { const h = this.tube.clientHeight, L = this.lvl(), lo = h * L.lo, hi = h * L.hi; return lo - (lo - hi) * (p + .5) / this.items.length; }
    level() { this.liq.style.height = Math.max(0, this.tube.clientHeight - this.lvl().base - this.y(this.pos)) + 'px'; this.drawSeq(); }
    ticks() {
      this.tube.querySelectorAll('.pc-tube__tick').forEach(t => t.remove());
      this.items.forEach((li, k) => {
        const t = document.createElement('i');
        t.className = 'pc-tube__tick' + (k === this.cur ? ' is-on' : '');
        t.style.top = this.y(k) + 'px'; this.tube.appendChild(t);
      });
    }
    // flou progressif sur ce qui dépasse en haut de la fenêtre
    blur() {
      const vr = this.view.getBoundingClientRect(), zone = this.zone();
      this.items.forEach(li => {
        const r = li.getBoundingClientRect(), c = r.top + r.height / 2 - vr.top;
        const t = Math.max(0, Math.min(1, (zone - c) / zone));
        li.style.filter = t > 0 ? `blur(${(.8 + t * 2).toFixed(2)}px)` : '';
        li.style.opacity = t > 0 ? (.75 - t * .35).toFixed(2) : '';
      });
    }

    /* ---------- contenant photoréaliste : suite d'images calculées ----------
       data-frames = URL de l'image 000 (pc-vial-000.webp, pc-tube-masque-000.webp…) ;
       l'image suit this.pos, comme le niveau. Chargement à l'approche de la section,
       l'image 0 d'abord puis du grossier au fin. */
    static seqIndex(pos, n, F) {
      return n > 1 ? Math.max(0, Math.min(F - 1, Math.round(pos / (n - 1) * (F - 1)))) : 0;
    }
    static seqOrder(F) {
      const out = [], vu = new Set(), add = k => { if (k >= 0 && k < F && !vu.has(k)) { vu.add(k); out.push(k); } };
      add(0); add(F - 1);
      for (let pas = F - 1; pas >= 1; pas = Math.floor(pas / 2)) {
        for (let k = 0; k < F; k += pas) add(k);
        if (pas === 1) break;
      }
      return out;
    }
    initSeq() {
      this.canvas = this.querySelector('.pc-vial__seq');
      if (!this.canvas || navigator.connection?.saveData) return;
      const F = +this.dataset.frameCount || 73, url0 = this.dataset.frames;
      const src = k => url0.replace(/-000(?=\.\w+(?:\?|$))/, '-' + String(k).padStart(3, '0'));
      const s = this.seq = { F, imgs: [], shown: -1 }, ordre = this.constructor.seqOrder(F);
      let i = 0;
      const suivant = () => {
        if (this.seq !== s || i >= ordre.length || !this.isConnected) return;
        const k = ordre[i++], img = new Image();
        img.onload = () => (img.decode ? img.decode() : Promise.resolve()).catch(() => {}).then(() => {
          if (this.seq !== s) return;
          s.imgs[k] = img; this.drawSeq();
          if (k === ordre[0]) { suivant(); suivant(); suivant(); } // puis 4 à la fois
          suivant();
        });
        img.onerror = () => { if (k === ordre[0]) this.seq = null; else suivant(); };
        img.src = src(k);
      };
      this.seqIO = new IntersectionObserver(([e]) => {
        if (e.isIntersecting) { this.seqIO.disconnect(); suivant(); }
      }, { rootMargin: '150% 0px' });
      this.seqIO.observe(this);
    }
    // l'image voulue, ou la plus proche déjà chargée
    drawSeq() {
      const s = this.seq;
      if (!s) return;
      const want = this.constructor.seqIndex(this.pos || 0, this.items.length, s.F);
      let k = -1;
      for (let d = 0; d < s.F && k < 0; d++) k = s.imgs[want - d] ? want - d : s.imgs[want + d] ? want + d : -1;
      if (k < 0 || k === s.shown) return;
      const c = this.canvas, img = s.imgs[k];
      if (c.width !== img.naturalWidth || c.height !== img.naturalHeight) { c.width = img.naturalWidth; c.height = img.naturalHeight; }
      c.getContext('2d').drawImage(img, 0, 0);
      s.shown = k; this.seqFrame = k;
      this.classList.add('is-seq');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-header"]) return;
  try {
    
/* Place le haut des panneaux latéraux sous le bandeau d'annonce.
   Le bandeau passe devant la sidebar quoi qu'on fasse : .menu-overlay est
   rendu par cette section, donc enfermé dans .pc-header-section (sticky,
   z-index:50) qui crée un contexte d'empilement ; .announce vit à 60 dans le
   contexte racine et gagne. Le panneau démarre donc sous lui, et le tiroir
   panier fait pareil pour que les deux s'ouvrent à la même hauteur.
   Le bandeau n'est pas fixe, il défile : on mesure ce qu'il en reste à
   l'écran AU MOMENT DE L'OUVERTURE. Entre l'ouverture et la fermeture,
   `body.menu-open{overflow:hidden}` gèle le défilement — la valeur ne peut
   pas se périmer. */
function pcPlaceSidePanels() {
  var ann = document.querySelector('.announce');
  var gap = ann ? Math.max(0, ann.getBoundingClientRect().bottom) : 0;
  /* Posé sur :root et non sur l'overlay : le tiroir panier lit la même
     variable, et lui est rendu par layout/theme.liquid, hors de cette
     section. Une propriété personnalisée hérite, la racine sert les deux. */
  document.documentElement.style.setProperty('--mp-gap', Math.round(gap) + 'px');
}
/* En capture : l'écouteur de pc-app.js est en bulle, celui-ci passe donc
   avant la pose de la classe `open` et le panneau glisse déjà bien placé. */
document.addEventListener('click', function (e) {
  if (e.target.closest && e.target.closest('[data-menu-open]')) pcPlaceSidePanels();
}, true);
/* Le tiroir panier s'ouvre aussi tout seul après un ajout, sans clic sur un
   bouton qu'on puisse écouter. pc-app.js pose `menu-open` sur <body> dans les
   deux cas : on observe cette classe, ce qui couvre les deux panneaux et
   ceux qu'on ajouterait ensuite. */
if (window.MutationObserver && document.body) {
  new MutationObserver(pcPlaceSidePanels)
    .observe(document.body, { attributes: true, attributeFilter: ['class'] });
}
window.addEventListener('resize', pcPlaceSidePanels);
pcPlaceSidePanels();

/* Fermeture au clic sur le voile. pc-app.js lit `q('[data-menu-close]')` au
   singulier : donner le même attribut au voile aurait volé l'écouteur à la
   croix. Le voile a donc le sien, ici, dans la section à laquelle il
   appartient — plutôt que de rouvrir pc-app.js pour un caractère. */
document.addEventListener('click', function (e) {
  if (!e.target.closest || !e.target.closest('[data-menu-scrim]')) return;
  var overlay = document.querySelector('[data-menu-overlay]');
  if (overlay) overlay.classList.remove('open');
  document.body.classList.remove('menu-open');
  var toggle = document.querySelector('[data-menu-open]');
  if (toggle) toggle.setAttribute('aria-expanded', 'false');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-footer-svc"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* --- pluie de pétales -----------------------------------------------------
     Quatre silhouettes dessinées, pas des gouttes : un pétale de cerisier
     échancré, une feuille nervurée, un pétale de rose bombé, un éclat étroit.
     Chacune porte un reflet clair d'un côté et un pli sombre : c'est ce qui
     fait lire un volume plutôt qu'une tache de couleur.

     Deux couches. Derrière le texte : petits, nets, lents, opaques jusqu'à 34 %.
     Devant : gros, flous, rapides, sous 15 %. Le flou de la couche proche est
     ce qui creuse la profondeur — sans lui tout tombe dans le même plan.

     La taille, la vitesse, l'opacité et l'amplitude du balancement sont liées à
     un même tirage `d` (0 = loin, 1 = près) : un gros pétale pâle et lent se
     verrait tout de suite comme une erreur de perspective.

     L'opacité plafonne à 34 % et ce n'est pas un arbitrage esthétique. Un
     pétale ivoire à 34 % sur le rose profond éclaircit le fond jusqu'à
     rgb(175,116,135) : les mentions légales y tombent de 4,9:1 à 2,8:1 le
     temps qu'il passe derrière. La présence se gagne donc par la taille et
     la silhouette, jamais par l'opacité. */
  var PETAL_SHAPES = [
    /* cerisier — échancré au sommet, effilé à la base */
    '<path d="M12 22.8C6.1 19 2.5 13.1 4.1 8.1 5.2 4.6 8.7 2.2 12 5.7c3.3-3.5 6.8-1.1 7.9 2.4 1.6 5-2 10.9-7.9 14.7Z"/>' +
    '<path d="M12 22.8C6.1 19 2.5 13.1 4.1 8.1 5.2 4.6 8.7 2.2 12 5.7Z" fill="#fff" opacity=".22"/>' +
    '<path d="M12 21.9c-.9-5.5-.9-10.9 0-15.9" fill="none" stroke="#4a1f2e" stroke-opacity=".17" stroke-width="1" stroke-linecap="round"/>',

    /* feuille — nervure centrale et trois nervures secondaires */
    '<path d="M13.4 1.5c6.8 4.1 8.6 11.7 3.7 17.6-2.9 3.5-7.7 4.1-11 1.4-4.2-3.4-3.7-10.2.3-14.4 2-2.1 4.4-3.7 7-4.6Z"/>' +
    '<path d="M13.4 1.5c6.8 4.1 8.6 11.7 3.7 17.6-1.5 1.8-3.5 2.8-5.5 2.9Z" fill="#fff" opacity=".16"/>' +
    '<path d="M7.2 21.4C8.8 14.6 10.3 8 13.4 1.5" fill="none" stroke="#4a1f2e" stroke-opacity=".2" stroke-width=".9" stroke-linecap="round"/>' +
    '<path d="M8.6 15.6 15.4 12.2M7.7 18.8 13.6 16M10.2 10.8 16 7.6" fill="none" stroke="#4a1f2e" stroke-opacity=".12" stroke-width=".7" stroke-linecap="round"/>',

    /* rose — large, bord du haut bombé, base pincée */
    '<path d="M12 22.9C8.4 19.6 3.2 15.6 2.9 10.4 2.7 5.6 6.6 1.6 12 1.6s9.3 4 9.1 8.8c-.3 5.2-5.5 9.2-9.1 12.5Z"/>' +
    '<path d="M12 22.9C8.4 19.6 3.2 15.6 2.9 10.4 2.7 5.6 6.6 1.6 12 1.6Z" fill="#fff" opacity=".2"/>' +
    '<path d="M6.6 15.8c3.2 2 7.6 2 10.8 0" fill="none" stroke="#4a1f2e" stroke-opacity=".15" stroke-width="1" stroke-linecap="round"/>',

    /* éclat — étroit, pour les tailles les plus lointaines */
    '<path d="M12 1.8c3.7 4.4 4.6 10.5 2.4 15.9-.9 2.2-1.7 3.7-2.4 4.5-.7-.8-1.5-2.3-2.4-4.5C7.4 12.3 8.3 6.2 12 1.8Z"/>' +
    '<path d="M12 22.2c-.7-.8-1.5-2.3-2.4-4.5C7.4 12.3 8.3 6.2 12 1.8Z" fill="#fff" opacity=".21"/>'
  ];

  /* Face visible / face cachée. Le dessous d'un pétale ne reçoit pas la lumière :
     sans cet écart de valeur, le demi-tour ne se voit pas. L'or n'apparaît qu'une
     fois sur huit — c'est un accent, pas une couleur de pluie. */
  var PETAL_TINTS = [
    ['#F4DDE5', '#D9AEBF'],
    ['#FDFBFC', '#E6CDD7'],
    ['#E8CFD8', '#CB9FB0'],
    ['#F7EDF1', '#DFC3CF'],
    ['#F4DDE5', '#D9AEBF'],
    ['#FDFBFC', '#E6CDD7'],
    ['#E8CFD8', '#CB9FB0'],
    ['#C9A46A', '#A07C46']
  ];

  function petalRnd(a, b) { return a + Math.random() * (b - a); }
  function petalPick(a) { return a[(Math.random() * a.length) | 0]; }

  function makePetal(near) {
    var d = Math.random();                 /* 0 = loin, 1 = près */
    var el = document.createElement('span');
    el.className = near ? 'slfd-petal is-blur' : 'slfd-petal';
    var s = el.style;
    var dur = near ? petalRnd(7, 11) : 21 - d * 9;

    s.setProperty('--x', petalRnd(-4, 100).toFixed(2) + '%');
    s.setProperty('--s', (near ? petalRnd(30, 54) : 12 + d * 20).toFixed(1) + 'px');
    s.setProperty('--d', dur.toFixed(2) + 's');
    s.setProperty('--delay', (-Math.random() * dur).toFixed(2) + 's');
    s.setProperty('--o', (near ? petalRnd(0.08, 0.15) : 0.16 + d * 0.18).toFixed(3));
    s.setProperty('--drift', (near ? petalRnd(40, 90) : 14 + d * 44).toFixed(0) + 'px');
    s.setProperty('--sway-d', petalRnd(3.2, 6.8).toFixed(2) + 's');
    s.setProperty('--sway-delay', (-petalRnd(0, 7)).toFixed(2) + 's');
    s.setProperty('--spin-d', petalRnd(4.5, 12).toFixed(2) + 's');
    s.setProperty('--spin-delay', (-petalRnd(0, 12)).toFixed(2) + 's');
    s.setProperty('--tz', petalRnd(-30, 30).toFixed(0) + 'deg');
    s.setProperty('--tx', petalRnd(-24, 24).toFixed(0) + 'deg');
    if (near) s.setProperty('--blur', petalRnd(2, 3.6).toFixed(1) + 'px');

    var t = petalPick(PETAL_TINTS);
    s.setProperty('--c', t[0]);
    s.setProperty('--c2', t[1]);

    /* Même tracé pour les deux faces : `rotateY(180deg)` le retourne, donc le
       dessous est le miroir du dessus — ce qu'est réellement un pétale. */
    var g = petalPick(PETAL_SHAPES);
    el.innerHTML = '<i class="slfd-sw"><i class="slfd-sp">' +
      '<svg viewBox="0 0 24 24">' + g + '</svg>' +
      '<svg viewBox="0 0 24 24" class="slfd-b">' + g + '</svg>' +
      '</i></i>';
    return el;
  }

  function fillPetals(host, near, n) {
    host.textContent = '';
    for (var i = 0; i < n; i++) host.appendChild(makePetal(near));
  }

  function init(root) {
    if (root.dataset.slfdInit) return;
    root.dataset.slfdInit = '1';

    var sels = root.querySelectorAll('[data-slfd-submit]');
    for (var s = 0; s < sels.length; s++) {
      sels[s].addEventListener('change', function () { this.form.submit(); });
    }

    var back = root.querySelector('[data-slfd-petals]'),
        near = root.querySelector('[data-slfd-petals-near]');
    if (!back) return;
    if (matchMedia('(prefers-reduced-motion:reduce)').matches) return;

    /* Le nombre suit le point de rupture : en mobile le pied de page est deux
       fois plus haut mais trois fois moins large, la même quantité y ferait
       une tempête. Il faut donc reconstruire au franchissement, pas seulement
       au chargement. */
    var wide = matchMedia('(min-width:760px)');

    function fill() {
      fillPetals(back, false, wide.matches ? 22 : 11);
      if (near) fillPetals(near, true, wide.matches ? 5 : 2);
      measure();
    }

    /* La hauteur du pied de page double entre desktop et mobile quand les
       colonnes s'empilent : sans cette mesure les pétales s'arrêteraient
       en l'air au lieu d'atteindre le bas. */
    function measure() {
      var v = (root.offsetHeight + 120) + 'px';
      back.style.setProperty('--fall', v);
      if (near) near.style.setProperty('--fall', v);
    }

    fill();
    wide.addEventListener('change', fill);
    if (window.ResizeObserver) { new ResizeObserver(measure).observe(root); }
    else { window.addEventListener('resize', measure); }
  }

  function mount() { document.querySelectorAll('[data-slfd]').forEach(init); }
  document.addEventListener('DOMContentLoaded', mount);
  mount();
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-slfd]').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-hero-frame"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.slInit) return;
    root.dataset.slInit = '1';

    var sws = root.querySelectorAll('[data-slhf-sw]');
    var nameEl  = root.querySelector('[data-slhf-name]');
    var priceEl = root.querySelector('[data-slhf-price]');
    var countEl = root.querySelector('[data-slhf-count]');
    var progEl  = root.querySelector('[data-slhf-prog]');
    var lineEl  = root.querySelector('[data-slhf-line]');
    var cta     = root.querySelector('[data-slhf-cta]');

    function select(i) {
      var b = sws[i];
      if (!b) return;
      var pct = ((i + 1) / sws.length) * 100;
      root.style.setProperty('--slhf-accent', b.dataset.accent);
      for (var j = 0; j < sws.length; j++) {
        sws[j].classList.toggle('is-on', j === i);
        sws[j].setAttribute('aria-pressed', j === i ? 'true' : 'false');
      }
      if (nameEl) {
        nameEl.style.opacity = 0;
        setTimeout(function () { nameEl.textContent = b.dataset.name; nameEl.style.opacity = 1; }, 170);
      }
      if (priceEl) priceEl.textContent = b.dataset.price || '';
      if (countEl) countEl.textContent = ('0' + (i + 1)).slice(-2);
      if (progEl)  progEl.style.width = pct + '%';
      if (lineEl)  lineEl.style.background =
        'linear-gradient(90deg,' + b.dataset.accent + ' 0%,' + b.dataset.accent + ' ' + pct + '%,transparent ' + pct + '%)';
      /* Le CTA suit le produit : sans ça le bouton renvoie sur la collection
         alors que le visiteur a déjà choisi un soin. */
      if (cta && b.dataset.url) cta.setAttribute('href', b.dataset.url);
    }

    for (var k = 0; k < sws.length; k++) {
      (function (idx) { sws[idx].addEventListener('click', function () { select(idx); }); })(k);
    }
    if (sws.length) select(0);
  }

  function boot() { document.querySelectorAll('[data-slhf]').forEach(init); }
  document.addEventListener('DOMContentLoaded', boot);
  boot();
  /* L'éditeur de thème remonte la section sans recharger la page. */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-slhf]').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
